import { styled } from '@mui/material';

export const Ul = styled('ul')({
  listStyleType: 'none',
  marginTop: 0,
  paddingLeft: 0,
});
